import * as React from 'react';
import DeleteIcon from '../../../asset/icons/Delete.esm.js';
import classNames from 'classnames';
import { testPageUrl } from '../../../utils/constants/urls.esm.js';
import useCollapsible from '../../../utils/hooks/useCollapsible/useCollapsible.esm.js';
import { getNumericBasePanelCode } from '../../../utils/stringFormatting.esm.js';
import styles$1 from '../OrderCard.module.esm.js';
import styles from './ReflexTest.module.esm.js';

var ReflexTest = function (_a) {
    var isAddon = _a.isAddon, isRnaAnalysisTestSelection = _a.isRnaAnalysisTestSelection, removeReflexTest = _a.removeReflexTest, test = _a.test;
    var _b = useCollapsible(), isOpen = _b.isOpen, setRef = _b.setRef, toggle = _b.toggle;
    var handleRemoveTestClick = React.useCallback(function (event) {
        event.stopPropagation();
        removeReflexTest(test);
    }, [test, removeReflexTest]);
    var toggleButtonTitle = React.useMemo(function () {
        return "".concat(isOpen ? 'HIDE' : 'SHOW', " GENES");
    }, [isOpen]);
    var geneNames = React.useMemo(function () {
        var _a;
        return (_a = test === null || test === void 0 ? void 0 : test.genes) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
            var name = _a.name;
            return name;
        }).sort();
    }, [test]);
    return (React.createElement("div", { className: isAddon ? styles.addOn : '' },
        React.createElement("div", { className: styles.reflexTest },
            React.createElement("div", { className: classNames(styles.reflexTestNameAndToggleButton, test.disabled && styles.disabledReflexTestNameAndToggleButton) },
                (function () {
                    if (isAddon) {
                        return test.name;
                    }
                    else if (isRnaAnalysisTestSelection) {
                        return (React.createElement("div", { className: styles.reflexConceptName, "data-testid": "reflex-test-name" }, test.name));
                    }
                    else {
                        return (React.createElement("a", { className: styles.link, "data-testid": "reflex-test-name", href: "".concat(testPageUrl).concat(getNumericBasePanelCode(test.code)), onClick: function (e) { return e.stopPropagation(); }, rel: "noopener noreferrer", target: "_blank" }, test.name));
                    }
                })(),
                !!(geneNames === null || geneNames === void 0 ? void 0 : geneNames.length) && (React.createElement("button", { className: classNames(styles$1.toggleGenesListBtn, styles.toggleGenesListBtn), "data-testid": "display-genes-button", onClick: function (e) {
                        e.stopPropagation();
                        toggle();
                    }, type: "button" }, toggleButtonTitle))),
            !test.disabled && (React.createElement("button", { className: styles.removeReflexTestButton, "data-testid": "delete-reflex-".concat(test.code), onClick: handleRemoveTestClick },
                React.createElement(DeleteIcon, { isSmall: true })))),
        React.createElement("div", { className: styles.genesList, "data-testid": "genes-container", ref: setRef }, geneNames.join(', '))));
};

export { ReflexTest as default };
//# sourceMappingURL=ReflexTest.esm.js.map
